import { render, staticRenderFns } from "./PhysicianRequest.vue?vue&type=template&id=096b486b&scoped=true&"
import script from "./PhysicianRequest.vue?vue&type=script&lang=js&"
export * from "./PhysicianRequest.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianRequest.vue?vue&type=style&index=0&id=096b486b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b486b",
  null
  
)

export default component.exports